import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import { base_url } from '../../url_variables';
import { TostMessageContext } from "../../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch, FaChalkboardTeacher, FaRegCalendarAlt, FaChild } from "react-icons/fa";
import { IoLibraryOutline } from "react-icons/io5";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { FaTasks } from "react-icons/fa";
import { SideMenu } from '../../components/sidebar';
import { TopBar } from '../../components/topbar';
import {ButtonSmall,ButtonWhite} from '../../components/buttons';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import '../../styling/calendar.css';
import { UserContext } from '../../context/UserContext';
import { ClockLoader } from 'react-spinners';
import { RouteDisplay } from '../../components/route_display';
import ProgressBarComponent from '../../components/progess_bar';
import { SetClassLinkModal } from '../../components/set_class_link';
import { SiGoogleclassroom } from 'react-icons/si';
import Chart from "react-apexcharts";

// type ValuePiece = Date | null;

// type Value = ValuePiece | [ValuePiece, ValuePiece];

function DashboardScreen() {
  const navigate = useNavigate();
  const [value, onChange] = useState(new Date());
//   const [calendarValues, setCalendarValues] = useState([]);
  const [loadingClasses, setLoadingClasses] = useState(false);
  const [loadingTasks, setLoadingTasks] = useState(false);
  const [cookies] = useCookies();
  const [tasks, setTasks] = useState([]);
  const { setTostMessage } = useContext(TostMessageContext);
  const {logOutFunction, calendarValues, setCalendarValues, userProfile} = useContext(UserContext);
  const [joiningRoom, setJoiningRoom] = useState(false);
  const [setClassLink, showSetClassLink] = useState(false);
  const [classLinkDets, setClassLinkDets] = useState({})
  const [overview, setOverview] = useState({});
  const [chartData, setChartData] = useState({categories: [], series: []});

  useEffect(() => {
    getClasses();
  }, []);

    function isSameDay(date1, date2) {
        return (
            new Date(date1).getFullYear() === date2.getFullYear() &&
            new Date(date1).getMonth() === date2.getMonth() &&
            new Date(date1).getDate() === date2.getDate()
        );
    }


  const getClasses = async () => {
    setLoadingClasses(true);
    try {
        const response = await axios.get(base_url + '/home/fetch_overview.php', {
            headers: {
                "Content-Type": "multipart/form-data",
                token: cookies?.userProfile?.session,
                main_id: cookies?.userProfile?.main_id,
                sub_id: cookies?.userProfile?.sub_id
            },
        });
        if (response.data.code == 403) {
            setLoadingClasses(false);
            setTostMessage({
                messageType: "error",
                message: response.data.response,
            });
            logOutFunction()
        }
        if (response.data.status) {
            setLoadingClasses(false);
            setOverview({ ongoing_classes: response.data.ongoing_classes, enrolled_students: response.data.enrolled_students, last_enrolled_students: response.data.last_enrolled_students, active_tutors: response.data.active_tutors, last_active_tutors: response.data.last_active_tutors, class_groups: response.data.class_groups  });
            setChartData(response.data.chart_data);
            setCalendarValues(response.data.calendar);
        } else {
            setLoadingClasses(false);
            setTostMessage({
                messageType: "error",
                message: response.data.response,
            });
        }
    } catch (error) {
        setLoadingClasses(false);
        setTostMessage({
            messageType: "error",
            message: 'Network error',
        });
    }
  }

  const joinClassroom = async (schedule_id, group_id, category, language_id, level_id) => {
    const formData = new FormData();
    if (category == 'GROUP') {
        formData.append('class_group', group_id)
        formData.append('schedule_id', schedule_id)
        formData.append('category', category);
    } else {
        formData.append('category', category);
        formData.append('language_id', language_id);
        formData.append('level_id', level_id);
        formData.append('schedule_id', schedule_id);
    }

    setJoiningRoom(true);
    console.log(schedule_id, group_id)
    try {
        const response = await axios.post(base_url + '/classes/join-class.php', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                token: cookies?.userProfile?.session,
                main_id: cookies?.userProfile?.main_id,
                sub_id: cookies?.userProfile?.sub_id
            },
        });
        if (response.data.code == 403) {
            setJoiningRoom(false);
            setTostMessage({
                messageType: "error",
                message: response.data.response,
            });
            logOutFunction()
        }
        if (response.data.status) {
            setJoiningRoom(false);
            if (response.data) {
                if (response.data.meeting_link != "") {
                    window.open(response.data.meeting_link, '_blank');
                } else {
                    setTostMessage({
                        messageType: "error",
                        message: 'Room link not set, please wait',
                    });
                }
            }
        } else {
            setJoiningRoom(false);
            setTostMessage({
                messageType: "error",
                message: response.data.response,
            });
        }
    } catch (error) {
        setJoiningRoom(false);
        setTostMessage({
            messageType: "error",
            message: 'Network error',
        });
    }
  }

  return (
    <div className="relative h-screen h-full">
        <div className="flex h-screen bg-[#F1F2F6]">
            {/* Sidebar */}
            <SideMenu />
            {/* Main content */}
            <main className="flex-1 p-8 overflow-y-auto">
                {/* Header */}
                <TopBar />
                <RouteDisplay />
                {setClassLink && (
                    <SetClassLinkModal 
                        schedule_id={classLinkDets?.schedule_id} 
                        category={classLinkDets?.category}
                        language_name={classLinkDets?.language}
                        level_name={classLinkDets?.level_name}
                        showSetClassLink={showSetClassLink}
                    />
                )}
                {joiningRoom && (
                    <div className='flex justify-center items-center w-fill-available h-full z-[999999] bg-[#ffffff] opacity-[0.6] fixed top-0'>
                        <div className='flex flex-col justify-center items-center w-[200px] h-[200px] rounded-[10px] bg-[#241D0C]'>
                            <a className='text-yellow text-lg font-bold mb-3'>Joining Room</a>
                            <ClockLoader
                                color={'#F4D00F'}
                                loading={joiningRoom}
                                size={60}
                                aria-label="Loading Spinner"
                                data-testid="loader1"
                            />
                        </div>
                    </div>
                )}
                <div className='flex flex-col justify-start w-full'>
                    <div className="grid bg-white grid-cols-2 md:grid-cols-4 gap-6">
                        {[
                        { title: 'Enrolled Students', value: overview?.enrolled_students ?? 0, change: ((overview?.enrolled_students - overview?.last_enrolled_students) / (overview?.last_enrolled_students == 0 ? 1 : overview?.last_enrolled_students)) * 100 + '%', last: overview?.last_enrolled_students, color: overview?.last_enrolled_students < overview?.enrolled_students ? 'text-green-500 bg-green-100' : 'text-red-500 bg-red-100' },
                        { title: 'Active Tutors', value: overview?.active_tutors ?? 0, change: ((overview?.active_tutors - overview?.last_active_tutors) / (overview?.last_active_tutors == 0 ? 1 : overview?.last_active_tutors)) * 100 + '%', last: overview?.last_active_tutors, color: overview?.last_active_tutors < overview?.active_tutors ? 'text-green-500 bg-green-100' : 'text-red-500 bg-red-100' },
                        { title: 'Class Groups', value: overview?.class_groups ?? 0, change: 'N/A', last: overview?.class_groups, color: 'text-green-500 bg-green-100' },
                        { title: 'Ongoing Classes', value: overview?.ongoing_classes ?? 0, change: 'N/A', last: overview?.ongoing_classes, color: 'text-green-500 bg-green-100' },
                        ].map((stat, idx) => (
                        <div key={idx} className="bg-white p-4">
                            <div className="text-sm text-gray-500">{stat.title}</div>
                            <div className="text-2xl font-bold text-gray-800">{stat.value}</div>
                            <div className="flex items-center mt-1 space-x-2 text-xs">
                            <span className={`px-2 py-0.5 rounded-full ${stat.color}`}>{stat.change}</span>
                            <span className="text-gray-400">Last week {stat.last}</span>
                            </div>
                        </div>
                        ))}
                    </div>
                    <div className="bg-white mt-6 p-6 w-full">
                        <div className="flex justify-between mb-4">
                            <h2 className="font-semibold text-lg">Classes Held</h2>
                            <span className="text-sm text-yellow-500 cursor-pointer"></span>
                        </div>
                        <div className="flex items-end gap-3 h-auto w-full">
                            <div className="mixed-chart w-full">
                                <Chart
                                options={{
                                    chart: {
                                        id: "basic-bar",
                                        type: "line",
                                        toolbar: { show: false },
                                    },
                                    plotOptions: {
                                        bar: {
                                        borderRadius: 6,
                                        columnWidth: '30%',
                                        distributed: true, // So you can color individual bars
                                        },
                                    },
                                    colors: ["#F4D00F", "#000aff"],
                                    dataLabels: {
                                        enabled: false,
                                    },
                                    stroke: {
                                        width: [4, 4]
                                    },    
                                    grid: {
                                        show: true,
                                        borderColor: '#E5E7EB', // Tailwind gray-200
                                        strokeDashArray: 4,
                                        padding: { top: 0, right: 0, bottom: 0, left: 0 },
                                    },
                                    xaxis: {
                                        categories: chartData?.categories,
                                        axisBorder: { show: false },
                                        axisTicks: { show: false },
                                        labels: {
                                            style: {
                                                colors: '#212121', // Tailwind gray-500
                                                fontSize: '10px',
                                            },
                                        },
                                    },
                                    yaxis: {
                                        labels: {
                                            style: {
                                                colors: '#212121', // Tailwind gray-400
                                                fontSize: '10px',
                                            },
                                        },
                                        axisBorder: { show: false },
                                        axisTicks: { show: false },
                                    },
                                }}
                                series={chartData?.series}
                                type="line"
                                height="350"
                                // width="500"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </div>
  );
}

export default DashboardScreen;
